import React from "react";

import { faTimesCircle } from "@fortawesome/pro-regular-svg-icons/faTimesCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import ImportStatus from "@mapmycustomers/shared/enum/imports/ImportStatus";
import Import from "@mapmycustomers/shared/types/imports/Import";

import getErrorTypeMessage from "@app/scene/settings/component/Imports/util/getErrorTypeMessage";

import styles from "./ErrorList.module.scss";

interface Props {
  importRecord?: Import;
}

const ErrorList: React.FC<Props> = ({ importRecord }) => {
  const intl = useIntl();
  if (
    !importRecord ||
    importRecord.status !== ImportStatus.ERRORED ||
    !importRecord.metadata.errorMessage
  ) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div>
        <FontAwesomeIcon className={styles.icon} icon={faTimesCircle} />
        <span>{getErrorTypeMessage(intl, importRecord.metadata.errorMessage.code)}</span>
      </div>
      {importRecord.metadata.errorMessage.errors.length > 0 && (
        <div className={styles.errors}>
          <span className={styles.errorDetails}>
            {intl.formatMessage({
              id: "import.upload.error.details.title",
              defaultMessage: "Error Details:",
              description: "Error details for import error",
            })}
          </span>
          {importRecord.metadata.errorMessage.errors.map((error, index) => {
            return (
              <div className={styles.errorItem} key={index}>
                <span>
                  {intl.formatMessage(
                    {
                      id: "import.upload.error.details.lineNumber",
                      defaultMessage: "Line: {index}",
                      description: "Error details for import error",
                    },
                    { index: error.lines }
                  )}
                </span>
                <span>{error.message}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ErrorList;
